import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './BrandsColumn.css';
import BrandItem from '../BrandItem/BrandItem';

class BrandsColumn extends Component {
  static propTypes = {
    brands: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        link: PropTypes.string.isRequired,
        count: PropTypes.number,
      }),
    ).isRequired,
    isLast: PropTypes.bool.isRequired,
    collapsed: PropTypes.bool.isRequired,
    handleClick: PropTypes.func.isRequired,
    onMakeChange: PropTypes.func,
    shouldShowBtn: PropTypes.bool,
  };

  static defaultProps = {
    shouldShowBtn: false,
    onMakeChange: null,
  };

  handleClick = () => {
    const { collapsed, handleClick } = this.props;
    handleClick(!collapsed);
  };

  render() {
    const { brands, isLast, collapsed, shouldShowBtn, onMakeChange } = this.props;

    return (
      <div className={s.root}>
        {brands.map(item =>
          <BrandItem
            onClick={onMakeChange ? () => onMakeChange(item) : undefined}
            key={item.id}
            title={item.title}
            link={item.link}
            count={item.count}
          />,
        )}

        {!isLast &&
          shouldShowBtn &&
          <div className={s.all} onClick={this.handleClick}>
            <FormattedMessage id={collapsed ? 'Все марки' : 'Только популярные'} />
          </div>}
      </div>
    );
  }
}

export default withStyles(s)(BrandsColumn);



// WEBPACK FOOTER //
// ./src/desktop/components/BrandsList/BrandsColumn/BrandsColumn.js